module.exports = __webpack_public_path__ + "img/card-providers-hover.5e2a75b8.svg";